import { reactive } from 'vue'
import router from '../../router'
const keySupportPortalStorage = 'MomsiteAccessToken'
let AccessToken = localStorage.getItem(keySupportPortalStorage)

export const auth = {
  state: reactive({
    loggedInState: !!AccessToken,
    accessToken: AccessToken
  }),
  actions: {
    storeAccessToken({ commit }, accessToken) {
      commit('setLoggedInStateAndToken', accessToken)
    },
    logout({ commit }) {
      commit('logout')
    },
    refreshAccessToken ({ commit }, accessToken) {
      commit('setLoggedInStateAndToken', accessToken)
    },
    unauthorizedAction ({ commit }) {
      if (router.currentRoute.name !== 'login') {
        alert('Either session is expired or you are not authorized for the action. Please try login again.', 'warning')
        commit('logout')
        router.push('login')
      }
    }
  },
  mutations: {
    setLoggedInStateAndToken(state, accessToken) {
      state.loggedInState = true
      state.accessToken = accessToken
      localStorage.setItem(keySupportPortalStorage, accessToken)
    },
    logout(state) {
      localStorage.removeItem(keySupportPortalStorage)
      state.loggedInState = false
      state.accessToken = null
    },
  },
}
